import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

class FlagUnitedStatesAmericaIcon extends Component {
  render() {
    return (
      <SvgIcon {...this.props} viewBox="0 0 7410 3900">
        <path fill="#b22234" d="M0 0h7410v3900H0z" />
        <path d="M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0" stroke="#fff" strokeWidth="300" />
        <path fill="#3c3b6e" d="M0 0h2964v2100H0z" />
        <g fill="#fff">
          <g id="d">
            <g id="c">
              <g id="e">
                <g id="b">
                  <path id="a" d="M247 90l71 217-185-134h228L176 307z" />
                  <use xlinkHref="#a" y="420"/>
                  <use xlinkHref="#a" y="840"/>
                  <use xlinkHref="#a" y="1260"/>
                </g>
                <use xlinkHref="#a" y="1680"/>
              </g>
              <use xlinkHref="#b" x="247" y="210"/>
            </g>
            <use xlinkHref="#c" x="494"/>
          </g>
          <use xlinkHref="#d" x="988"/>
          <use xlinkHref="#c" x="1976"/>
          <use xlinkHref="#e" x="2470"/>
        </g>
      </SvgIcon>
    );
  }
}

FlagUnitedStatesAmericaIcon.propTypes = {
  classes: PropTypes.object,
};

export default FlagUnitedStatesAmericaIcon;



// WEBPACK FOOTER //
// ./src/FlagUnitedStatesAmericaIcon.js